import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { RiskScaleComponent } from '../risk-scale/risk-scale.component';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { concatMap, from, of, tap } from 'rxjs';
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-risk-settings',
  templateUrl: './risk-settings.component.html',
  styleUrls: ['./risk-settings.component.scss']
})

export class RiskSettingsComponent implements OnInit {

  isProcessing = true;
  riskSettingsData: any = {};
  auditTrail: any = {};

  selectedTabName: any;
  selectedTabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTabName = $event.tab.textLabel;
    this.selectedTabIndex = $event.index;
    this.selectedTabIndex == 0 && this.getCall();
  }

  constructor(
    private readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef,
    public router: Router,
    public message: messageService,
    public dialog: MatDialog,
    public qmsService: qmsService,
    public paginationService: PaginationService) {

    this.qmsService.selectedRiskModule = null;
  }

  @ViewChild(RiskScaleComponent) riskScaleComponent: RiskScaleComponent;

  selectedRiskCategory: any = null;
  selectedApplicableGroups: any = [];

  dropdownForModule: any = [];
  dropdownForRiskCategory: any = [];
  dropdownForApplicableGroups: any = [];

  moduleDropdown: any = [];
  riskCategoryDropdown: any = [];
  applicableGroupsDropdown: any = [];

  moduleSearchText: string = '';
  applicableGroupsSearchText: string = '';
  riskCategorySearchText: string = '';

  oddRiskCategory: any = null;

  ngOnInit() {
    this.isProcessing = true;

    this.dropdownForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') ?? '{}');
    this.selectBoxForModule();

    this.appService.getCodeListsByGroup('RISK_CATEGORY').subscribe((data: any) => {
      this.dropdownForRiskCategory = data;
      this.isProcessing = false;
      this.selectBoxForRiskCategory();
    })
  }

  selectBoxForModule() {
    this.moduleDropdown = [];
    const excludedCodes = new Set(['DOCS', 'TRN', 'BP']);

    this.moduleDropdown = this.dropdownForModule
      ?.filter((item: any) => !excludedCodes.has(item.codelistCode))
      .map((item: any) => ({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      }))
      ?.sort((m: { displayExp: string }, n: { displayExp: string }) =>
        m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())
      ) || [];
  }

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        [this.selectedApplicableGroups, this.dropdownForApplicableGroups, this.applicableGroupsDropdown] = [[], [], []];
        this.isProcessing = true;
        if (this.selectedTabIndex == 0) {
          this.appService.getQmsGroupsByModule(item.valueExp).subscribe((moduleData: any) => {
            this.dropdownForApplicableGroups = moduleData;
            this.selectBoxForApplicableGroups();
            this.isProcessing = false;
          })
          this.getCall();
        } else {
          this.riskScaleComponent.getCall(); this.isProcessing = false;
        };
      } else {
        this.isProcessing = false;
      }
    }
  }

  selectBoxForRiskCategory() {
    this.riskCategoryDropdown = [];
    this.riskCategoryDropdown = this.dropdownForRiskCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  onRiskCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.handleDropDownValidation('risk-category-validation', this.selectedRiskCategory) })
    }
  }

  selectBoxForApplicableGroups() {
    this.applicableGroupsDropdown = [];
    this.applicableGroupsDropdown = this.dropdownForApplicableGroups?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onApplicableGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isApplicableGroupsSelected = this.applicableGroupsDropdown.length == this.selectedApplicableGroups.length;
      })
    }
  }

  @ViewChild('applicableGroup') applicableGroup: MatSelect;
  isApplicableGroupsSelected: boolean = false;

  toggleAllSelection(value: string) {
    if (value == 'applicableGroup') {
      if (this.isApplicableGroupsSelected) {
        this.applicableGroup.options.forEach((item: MatOption) => item.select());
      } else {
        this.applicableGroup.options.forEach((item: MatOption) => item.deselect());
      }
    }
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  selectedColumnsAsString: string = "";
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isExeclPdf = ['applicable-Group'].includes(fieldId);
    const isSelected = isExeclPdf ? !selectedItems.length : !selectedItems;
    const isFieldValid = field;
    if (isSelected && isFieldValid) {
      field.style.color = 'red';
    } else {
      field.style.color = '#005c8a';
    }
  }

  validateNoFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('updatePopup', { static: true }) updatePopup: TemplateRef<any>;
  visibleUpdatePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  resultPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  updatePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  operationFlag: string = '';

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Add Risk Settings";
    this.criteriaList = ['Create New', 'Copy'];
    this.selectedCriteria = 'Create New';
    [this.riskSettingsData.riskCategoryName, this.riskSettingsData.riskCategoryScale, this.riskSettingsData.comments] = ["", "", ""];
    [this.selectedApplicableGroups, this.selectedRiskCategory, this.isApplicableGroupsSelected] = [[], null, false];
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingRiskId: any;
  openEditPopup(editingData: any, type: string, index: number) {
    if (index == 0) {
      this.isProcessing = true;
      this.visibleAddButton = false;
      this.visibleEditButton = type == 'edit';
      this.operationFlag = 'EDIT';
      this.selectedCriteria = 'Update';
      this.popupDataTitle.title = type == 'edit' ? "Edit Risk Settings" : 'View Risk Settings';
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      this.editingRiskId = editingData.RISK_ID;
      this.appService.getRiskSettingsByRiskId(this.editingRiskId).subscribe((riskData: any) => {

        if (riskData.riskCategory) {
          const matchingRiskCategory = this.dropdownForRiskCategory?.find((item: any) => item.codelistCode == riskData.riskCategory);
          if (!matchingRiskCategory) {
            this.oddRiskCategory = riskData.riskCategory;
            this.riskCategoryDropdown.push({
              valueExp: riskData.riskCategory,
              displayExp: riskData.riskCategory
            })
          }
          this.selectedRiskCategory = riskData.riskCategory;
        }

        if (riskData.applicableGroups) {
          this.selectedApplicableGroups = riskData.applicableGroups.split(',').map(Number);
          setTimeout(() => {
            this.isApplicableGroupsSelected = this.applicableGroupsDropdown.length == this.selectedApplicableGroups.length;
            riskData.applicableGroups.split(',').length == this.dropdownForApplicableGroups.length && this.applicableGroup.options.forEach((item: MatOption) => item.select());
          })
        }

        this.riskSettingsData = riskData;
        this.isProcessing = false;
      })
    }
  }

  deletingRiskId: any;
  openDeletePopup(deletingData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Risk Settings";
    this.deletingRiskId = deletingData.RISK_ID;
    this.riskSettingsData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  addAndEditFunction(riskData: any) {

    const validations = [
      { condition: !this.qmsService.selectedRiskModule, id: 'module-validation' },
      { condition: !this.selectedRiskCategory, id: 'risk-category-validation' },
      { condition: !riskData.riskCategoryName, id: 'risk-category-name-validation' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;
      const data = {
        module: this.qmsService.selectedRiskModule ?? null,
        riskCategory: this.selectedRiskCategory ?? null,
        riskCategoryName: riskData.riskCategoryName,
        riskCategoryScale: riskData.riskCategoryScale,
        applicableGroups: this.selectedApplicableGroups?.map(String).join(','),
        comments: riskData.comments
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createRiskSettings(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...data,
          riskId: this.editingRiskId
        }
        this.appService.updateRiskSettings(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    if (this.qmsService.isCopyingRisk) { this.qmsService.isCopyingRisk = false; this.getCall(); }
    this.visibleAddAndEditPopup.close();
  }

  deleteFunction(ccpData: any) {
    if (this.riskSettingsData.deleteReason) {
      this.isProcessing = true;

      const data = {
        riskId: this.deletingRiskId,
        deleteReason: ccpData.deleteReason
      }

      this.appService.deleteRiskSettings(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    this.selectedGridData = [];
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "RISK_SETTINGS",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_RISK_SETTINGS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          module: this.qmsService.isCopyingRisk ? this.selectedSourceModule ?? null : this.qmsService.selectedRiskModule ?? null,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.dynamicLabelCall()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';

          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;

  onParentChanged(e: any) {
    if (e.target.checked) {
      this.selectedGridData = this.pagedItems.length == 10 ? this.grid : this.pagedItems;

      if (!this.qmsService.isCopyingRisk) {
        this.isMultipleRowSelected = true;
        this.isSameCategorySelected = this.selectedGridData.every((r: any) => r.RISK_CATEGORY.toLowerCase() == this.selectedGridData[0].RISK_CATEGORY.toLowerCase());
      }

      for (const element of this.grid) { element.childCheckBox = true }
    } else {

      [this.isMultipleRowSelected, this.isSameCategorySelected, this.selectedGridData] = [false, false, []];
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.onChildUnchecked(list);
    }

    setTimeout(() => {
      if (!this.qmsService.isCopyingRisk) {
        this.isMultipleRowSelected = this.selectedGridData.filter((r: any) => r.childCheckBox).length > 1;
        this.isMultipleRowSelected && (this.isSameCategorySelected = this.selectedGridData.every((r: any) => r.RISK_CATEGORY == this.selectedGridData[0].RISK_CATEGORY));
      }
    })
  }

  onChildChecked(checked: any) {
    if (!this.selectedGridData?.some((copied: any) => copied.RISK_ID === checked.RISK_ID)) {
      this.selectedGridData.push(checked);
    }

    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  onChildUnchecked(unchecked: any) {
    this.selectedGridData = this.selectedGridData?.filter((copied: any) => copied.RISK_ID !== unchecked.RISK_ID);
  }

  refreshGridData() {
    this.getCall();
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value); searchBox?.focus();
    }, 0)
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, riskScale: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : riskScale.RISK_ID;
    this.auditTrail.gridName = 'RISK_SETTINGS';
    this.auditTrail.report_And_Popup_Name = 'Risk Settings Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(riskScale);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Risk Settings Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectedCriteria: any;
  criteriaList: any = [];
  selectedGridData: any = [];

  onSearchCriteriaChanged(criteria: any) {

    if (criteria == 'Create New') {
      [
        this.riskSettingsData.riskCategoryName,
        this.riskSettingsData.riskCategoryScale,
        this.riskSettingsData.comments,
        this.selectedApplicableGroups,
        this.selectedRiskCategory,
        this.qmsService.isCopyingRisk
      ] = ["", "", "", [], null, false];

      this.getCall();
    } else if (criteria == 'Copy') {
      [
        this.pagedItems,
        this.grid,
        this.selectedGridData,
        this.responses,
        this.selectedSourceModule,
        this.selectedTargetModule,
        this.selectedApplicableGroups,
        this.parentCheckBox,
        this.qmsService.isCopyingRisk
      ] = [[], [], [], [], null, null, null, false, true];

      this.isApplicableGroupsSelected = false;
    }
  }

  selectedSourceModule: any;
  selectedTargetModule: any
  onSourceModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;
        this.appService.getQmsGroupsByModule(item.valueExp).subscribe((moduleData: any) => {
          this.dropdownForApplicableGroups = moduleData;
          this.selectBoxForApplicableGroups();
          this.isProcessing = false;
        })
        this.getCall();
      } else {
        this.isProcessing = false;
      }
    }
  }

  onTargetModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;
        this.appService.getQmsGroupsByModule(item.valueExp).subscribe((moduleData: any) => {
          this.dropdownForApplicableGroups = moduleData;
          this.selectBoxForApplicableGroups();
          this.isProcessing = false;
        })
      } else {
        this.dropdownForApplicableGroups = [];
        this.selectedApplicableGroups = null;
      }
    }
  }

  responses: any[] = []; /* To store the responses sequentially */

  update(usingFor: string) {
    this.isProcessing = true;
    from(this.selectedGridData) /* 'from' converts the array into an observable stream */
      .pipe(
        concatMap((setting: any, index: number) => { /* 'concatMap' ensures that the next API call does not start until the current one is complete */

          let risk: { [key: string]: any };

          if (this.qmsService.isCopyingRisk) {
            risk = {
              module: this.selectedTargetModule,
              riskCategory: setting.RISK_CATEGORY,
              riskCategoryName: setting.RISK_CATEGORY_NAME,
              riskCategoryScale: setting.RISK_CATEGORY_SCALE,
              applicableGroups: this.selectedApplicableGroups?.map((item: any) => item).join(','),
              comments: setting.COMMENTS
            }
          } else {
            let group = null;
            if (usingFor == 'group') {
              if (this.selectedCriteria == 'Append') {
                const selectedIds = this.selectedApplicableGroups.map(Number); // Convert to numbers
                const settingIds = setting.APPLICABLE_GROUPS ? setting.APPLICABLE_GROUPS.split(',').map(Number) : [];
                const filteredIds = selectedIds.filter((id: any) => !settingIds.includes(id));
                group = [...filteredIds, ...settingIds].join(',');
              } else {
                group = this.selectedApplicableGroups?.map((item: any) => item).join(',')
              }
            }
            risk = {
              riskId: setting.RISK_ID,
              module: setting.MODULE,
              riskCategory: usingFor == 'group' ? setting.RISK_CATEGORY : this.selectedRiskCategory,
              riskCategoryName: setting.RISK_CATEGORY_NAME,
              riskCategoryScale: setting.RISK_CATEGORY_SCALE,
              applicableGroups: group,
              comments: setting.COMMENTS
            }
          }

          /*  Call the API for the current setting */
          const method = usingFor == 'copy' ? 'createRiskSettings' : 'updateRiskSettings';

          return this.appService[method](risk).pipe(
            tap((Response: any) => { /* 'tap' is an operator used to perform side effects for debugging or performing actions without altering the data flowing through the observable stream */
              /* Store the response after the API call */
              this.responses[index] = { setting, response: Response, ...usingFor == 'risk_category' && { toCategory: this.selectedRiskCategory }, ...usingFor == 'group' && { toGroup: this.applicableGroupsDropdown.filter((group: any) => this.selectedApplicableGroups.includes(group.valueExp)).map((group: any) => group.displayExp).join(',') }, usingFor: usingFor };
            }),
            /* Ensure the observable emits a value for next() */
            concatMap(() => of(setting))
            /* 'of(setting)' creates an observable that emits the current setting after the API call is complete.
               This observable is processed by the from pipeline and triggers the next handler for every iteration */
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item); /* Logs the processed item where this next is triggered by of(setting) */
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses); /* Log the final responses array */
          this.isProcessing = false;
          usingFor == 'copy' && this.visibleAddAndEditPopup.close();
          if (usingFor !== 'copy') {
            this.visibleUpdatePopup.close();
            this.isMultipleRowSelected = false;
            this.isSameCategorySelected = false;
          }
          this.resultPopupTitle = usingFor;
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }

  cancelResultPopup() {
    this.qmsService.isCopyingRisk = false;
    this.getCall();
    this.visibleResultPopup.close();
  }

  isMultipleRowSelected: boolean = false;
  isSameCategorySelected: boolean = false;
  group_or_risk: string = '';
  resultPopupTitle: string = '';

  open_group_or_risk_popup(e: string) {
    if (e === 'group') {
      this.selectedApplicableGroups = null;
    } else {
      this.selectedRiskCategory = null;
    }

    this.group_or_risk = e;
    this.criteriaList = ['Replace', 'Append'];
    this.selectedCriteria = this.selectedApplicableGroups = this.selectedRiskCategory = null;
    this.visibleUpdatePopup = this.dialog.open(this.updatePopup, this.updatePopupConfig);
  }

  close_group_or_risk_popup() {
    this.visibleUpdatePopup.close();
  }

  public focusEmpty(): void {
    console.log();
  }

}
